import React, { useState } from "react";
import Sidebar from "../../components/Sidebar/Sidebar";
import Form from "../../components/Home/Form/Form";

const NewAgent = () => {
  const date = new Date().toISOString().substr(0, 10);
  const [arriveData, setArriveData] = useState(date);
  return (
    <div className="newAgent">
      <div className="left">
        <Sidebar />
      </div>
      <div className="right">
        <Form newAgent arriveData={arriveData} setArriveData={setArriveData} />
      </div>
    </div>
  );
};

export default NewAgent;
